import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import EvidencePdfPage from '@/pages/export/evidence-pdf'

export const Route = createFileRoute('/export/evidence-pdf/')({
  validateSearch: z.object({ token: z.string() }),
  component: EvidencePdfPage,
})
